export default __webpack_public_path__ + "static/search-right-bottom-013b7f7c1c8db0477e5e350f1bf0593a.png";